import { render, staticRenderFns } from "./Servicetron.vue?vue&type=template&id=2ec06411&scoped=true&"
import script from "./Servicetron.vue?vue&type=script&lang=js&"
export * from "./Servicetron.vue?vue&type=script&lang=js&"
import style0 from "./Servicetron.vue?vue&type=style&index=0&id=2ec06411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec06411",
  null
  
)

export default component.exports